export default __webpack_public_path__ + "static/media/right.99caa7e2.svg";